import { motion } from 'motion/react'
import RichText from 'src/components/RichText'
import { mq, pxToRem, sizes } from 'src/theme'
import { MotionMask } from 'src/theme/styled'
import styled, { css } from 'styled-components'

export const Container = styled(motion.section)`
  position: relative;
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(56)};
  width: 100%;
  max-width: calc(100% - ${pxToRem(16)} * 2);
  margin-inline: auto;
  padding-block-start: ${pxToRem(24)};
  &:not(:first-child) {
    margin-block-start: var(--g_spacing__blocks);
  }
  @media ${mq(sizes.desktop)} {
    flex-flow: row;
    gap: ${pxToRem(16)};
    max-width: calc(100% - ${pxToRem(32)} * 2);
  }
`

export const Title = styled.h2`
  ${({ theme }) => theme.textStyles.m375_h1}
  flex: 1 1 0;
  text-wrap: balance;
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.d1440_h1}
  }
`

export const _MotionMask = styled(MotionMask)`
  @media ${mq(sizes.desktop)} {
    flex: 1 1 0;
  }
`

export const _RichText = styled(RichText)<{ $isSecondary?: boolean }>`
  ${({ $isSecondary }) =>
    $isSecondary
      ? css`
          ${({ theme }) => theme.textStyles.m375_body}
        `
      : css`
          ${({ theme }) => theme.textStyles.m375_editoChapo}
        `}
  @media ${mq(sizes.desktop)} {
    ${({ $isSecondary }) =>
      $isSecondary
        ? css`
            ${({ theme }) => theme.textStyles.d1440_editoBody}
          `
        : css`
            ${({ theme }) => theme.textStyles.d1440_editoChapo}
          `}
  }
`
